import React from 'react';
import {teamRoleColor} from '../../utils/teamRoleDisplay';

const groups={team:'team','coaching staff':'coach',players:'player',player:'player',coaches:'coach',coach:'coach',analysts:'analyst',analyst:'analyst',managers:'manager',manager:'manager',subs:'sub',sub:'sub',trial:'trial',trials:'trial',trialing:'trial',trialling:'trial',spectator:'spectator',spectators:'spectator'};
const escape=value=>value.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');
export function splitNoteMentions(text,roles={}){
  const source=String(text??''),directory=Object.fromEntries(Object.entries(roles).map(([name,role])=>[name.replace(/^@\s*/,'').replace(/\s+/g,' ').trim().toLowerCase(),role]));
  const names=[...new Set([...Object.keys(groups),...Object.keys(directory)].filter(Boolean))].sort((a,b)=>b.length-a.length);
  const expression=new RegExp('(^|[^\\p{L}\\p{N}_@])(@\\s*(?:'+names.map(name=>name.split(/\s+/).map(escape).join('\\s+')).join('|')+'))(?=$|[^\\p{L}\\p{N}_-])','giu');
  const output=[];let cursor=0,match;
  while((match=expression.exec(source))){
    const start=match.index+match[1].length,end=start+match[2].length;
    const prefix=source.slice(0,start).split(/\s/).at(-1);
    if(/https?:\/\/|www\./i.test(prefix))continue;
    if(start>cursor)output.push({text:source.slice(cursor,start)});
    const key=match[2].replace(/^@\s*/,'').replace(/\s+/g,' ').toLowerCase();
    output.push({text:source.slice(start,end),role:groups[key]||directory[key],mention:true});cursor=end;
  }
  if(cursor<source.length)output.push({text:source.slice(cursor)});
  return output;
}

// React text nodes preserve escaping and whitespace. Only the mention receives
// a color; the surrounding message keeps its normal text color.
export default function InlineNoteText({text,roles={}}){
  return <>{splitNoteMentions(text,roles).map((part,index)=>part.mention?<span key={index} className="note-inline-mention" data-role={part.role} style={{color:part.role==='team'?'var(--Rev-NotesDisplay-mention-team-clr,var(--clr22bbd7,#22bbd7))':teamRoleColor(part.role)}}>{part.text}</span>:part.text)}</>;
}
